export default __webpack_public_path__ + "static/media/IBMLink.c07ced3f.svg";